import React, { useState } from 'react';

export default function AcademyActivationCredentials({
  mode,
  onModeChange,
  onLogin,
  onRegister,
  busy,
  notice,
  error
}) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  async function submit(event) {
    event.preventDefault();
    if (mode === 'register' && password !== confirmPassword) {
      onRegister({ email, password: '', validationError: 'Passordene er ikke like.' });
      return;
    }

    const submitAction = mode === 'register' ? onRegister : onLogin;
    await submitAction({ email, password });
    setPassword('');
    setConfirmPassword('');
  }

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-7">
      <div className="grid grid-cols-2 rounded-xl bg-slate-100 p-1">
        <button
          type="button"
          onClick={() => onModeChange('register')}
          className={`rounded-lg px-3 py-2.5 text-sm font-semibold transition ${mode === 'register' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500'}`}
        >
          Registrer konto
        </button>
        <button
          type="button"
          onClick={() => onModeChange('login')}
          className={`rounded-lg px-3 py-2.5 text-sm font-semibold transition ${mode === 'login' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500'}`}
        >
          Logg inn
        </button>
      </div>

      {notice && <p role="status" className="mt-5 rounded-xl bg-blue-50 p-4 text-sm leading-6 text-blue-900">{notice}</p>}
      {error && <p role="alert" className="mt-5 rounded-xl bg-rose-50 p-4 text-sm leading-6 text-rose-800">{error}</p>}

      <form onSubmit={submit} className="mt-5 space-y-4">
        <label className="block">
          <span className="mb-2 block text-sm font-semibold text-slate-700">E-postadresse</span>
          <input
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10"
          />
        </label>
        <label className="block">
          <span className="mb-2 block text-sm font-semibold text-slate-700">Passord</span>
          <input
            type="password"
            autoComplete={mode === 'register' ? 'new-password' : 'current-password'}
            minLength={8}
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10"
          />
        </label>
        {mode === 'register' && (
          <label className="block">
            <span className="mb-2 block text-sm font-semibold text-slate-700">Gjenta passord</span>
            <input
              type="password"
              autoComplete="new-password"
              minLength={8}
              required
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10"
            />
          </label>
        )}
        <button
          type="submit"
          disabled={busy}
          className="w-full rounded-xl bg-blue-700 px-4 py-3 font-bold text-white transition hover:bg-blue-800 disabled:cursor-wait disabled:opacity-60"
        >
          {busy ? 'Vennligst vent …' : mode === 'register' ? 'Opprett konto' : 'Logg inn'}
        </button>
      </form>
    </div>
  );
}